import { TColumItem } from '../components/types';

/**
 * Will return the name of the store
 *
 * @param {*} field field where to populated
 * @return {*}  {string}
 */
export const getStoreField = (item: TColumItem): string => {
    if ('store' in item) return `${item.store?.name || ''}`;

    return '- - -';
};
